import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';

import qrCode from './QrCode';

export class LoyaltyCardScanner extends LightLitElement {
    static get properties() {
        return {
            cssClass: { type: String, attribute: 'css-class' },
            LoyaltyCardValue: { type: String, attribute: 'loyalty-card-value' },
        };
    }

    constructor() {
        super();
        this.cssClass = '';
        this.LoyaltyCardValue = '1234';
    }

    render() {
        let errorCorrectionLevel = 'L';
        let qr = qrCode(0, errorCorrectionLevel);
        qr.addData(this.LoyaltyCardValue, 'Numeric');
        qr.make();
        // document.getElementById('placeHolder').innerHTML = qr.createImgTag();
        return html`
            <img class="${this.cssClass}" src="${qr.createDataURL(4, 4)}"> </img>
        `;
    }
}

export default () =>
    customElements.define('e2-loyalty-scanner', connect(null, null)(LoyaltyCardScanner));
